// extracted by mini-css-extract-plugin
export default {"icon":"PaymentProtectionBadge--icon--8545cb","link":"PaymentProtectionBadge--link--24817b"};